// Central place to control the public site origin used for SEO (canonical, OG urls, schema urls).
// IMPORTANT: during pre-render/build (react-snap) `window.location.origin` may not equal production domain.

export const SITE_BASE_URL = 'https://directory.visibeen.com';

export const getSiteBaseUrl = () => {
  // For SEO/Schema purposes, ALWAYS return the production URL
  // This ensures schema validators and search engines see correct URLs
  // regardless of whether the app is running locally or in production
  //
  // Priority:
  // 1) REACT_APP_SITE_BASE_URL environment variable (for different environments)
  // 2) Always use production SITE_BASE_URL for consistent SEO
  if (
    typeof process !== 'undefined' &&
    process.env &&
    process.env.REACT_APP_SITE_BASE_URL
  ) {
    return process.env.REACT_APP_SITE_BASE_URL;
  }

  // Always return production URL for schema/SEO consistency
  return SITE_BASE_URL;
};

/**
 * Get the current runtime URL (for non-SEO purposes like API calls)
 * This returns localhost in development
 */
export const getRuntimeBaseUrl = () => {
  try {
    if (typeof window !== 'undefined' && window.location && window.location.origin) {
      return window.location.origin;
    }
  } catch (_) {
    // ignore
  }
  return SITE_BASE_URL;
};
